var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3268 11.2323L11.3268 11.2319L11.5737 3.61141H12.6895C12.8879 3.61141 13.05 3.44933 13.05 3.25096C13.05 3.05258 12.8879 2.8905 12.6895 2.8905H9.4795V2.24195C9.4795 1.53125 8.89825 0.95 8.18755 0.95H5.82798C5.11728 0.95 4.53603 1.53125 4.53603 2.24195V2.8905H1.31045C1.11207 2.8905 0.95 3.05258 0.95 3.25096C0.95 3.44933 1.11208 3.61141 1.31045 3.61141H2.42635L2.67319 11.2319L2.6732 11.2323C2.72082 12.4387 3.68967 13.3761 4.89648 13.3761H9.10352C10.3104 13.3761 11.2792 12.4388 11.3268 11.2323ZM4.9121 12.6551C4.10168 12.6551 3.44125 12.0259 3.40967 11.2005L3.40958 11.1977L3.40955 11.1975L3.16284 3.59594H10.868L10.606 11.1974C10.606 11.1975 10.606 11.1975 10.606 11.1976C10.5759 12.0093 9.91449 12.6551 9.10359 12.6551H4.9121ZM5.25699 2.24193C5.25699 1.92801 5.51398 1.67102 5.8279 1.67102H8.18758C8.50149 1.67102 8.75848 1.92801 8.75848 2.24192V2.89048H5.25691L5.25699 2.24193Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95674 10.7631V10.7667H7.00674C7.20513 10.7667 7.3672 10.6046 7.3672 10.4062V5.76455C7.3672 5.56617 7.20512 5.4041 7.00674 5.4041C6.80837 5.4041 6.64629 5.56618 6.64629 5.76455V10.4062C6.64629 10.5876 6.78185 10.7386 6.95674 10.7631Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09444 10.7631V10.7667H5.14444C5.34282 10.7667 5.50489 10.6046 5.50489 10.4062V5.76455C5.50489 5.56617 5.34281 5.4041 5.14444 5.4041C4.94605 5.4041 4.78398 5.56618 4.78398 5.76455V10.4062C4.78398 10.5876 4.91954 10.7386 5.09444 10.7631Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81709 10.7631V10.7667H8.86709C9.06548 10.7667 9.22755 10.6046 9.22755 10.4062V5.76455C9.22755 5.56617 9.06547 5.4041 8.86709 5.4041C8.66871 5.4041 8.50664 5.56618 8.50664 5.76455V10.4062C8.50664 10.5876 8.6422 10.7386 8.81709 10.7631Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8aa8c8ba56b673d0d0a8d07df1ae154b.svg";
export { ForwardRef as ReactComponent };